<div class="filter-bar">
  <input class="filter-input" [(ngModel)]="galaxySearch" placeholder="Search system or owner…" autocomplete="off" *ngIf="galaxyView === 'list'">
  <span class="filter-spacer" *ngIf="galaxyView === 'map'"></span>
  <div class="view-toggle">
    <button class="view-btn" [class.active]="galaxyView === 'list'" (click)="galaxyView = 'list'" title="List view">List</button>
    <button class="view-btn" [class.active]="galaxyView === 'map'"  (click)="galaxyView = 'map'"  title="Map view">Map</button>
  </div>
</div>

<!-- List view -->
<div class="galaxy-table" *ngIf="galaxyView === 'list'">
  <div class="galaxy-header">
    <span class="galaxy-col-sys sort-col" (click)="setGalaxySort('id')">System<span class="sort-ind">{{ galaxySortBy === 'id' ? (galaxySortAsc ? ' ↑' : ' ↓') : '' }}</span></span>
    <span class="galaxy-col-owner sort-col" (click)="setGalaxySort('owner')">Fleet Owner<span class="sort-ind">{{ galaxySortBy === 'owner' ? (galaxySortAsc ? ' ↑' : ' ↓') : '' }}</span></span>
    <span class="galaxy-col-timer sort-col" (click)="setGalaxySort('cooldown')">Cooldown<span class="sort-ind">{{ galaxySortBy === 'cooldown' ? (galaxySortAsc ? ' ↑' : ' ↓') : '' }}</span></span>
  </div>
  <div class="galaxy-row" *ngFor="let s of ownedSystems">
    <span class="galaxy-col-sys">{{ systemTitle(s.starSystemId) }}</span>
    <span class="galaxy-col-owner">{{ s.ownerName || '—' }}</span>
    <span class="galaxy-col-timer" [class]="cooldownClass(s.engagementCooldownEndDate)">
      {{ formatTimerDate(s.engagementCooldownEndDate) }}
    </span>
  </div>
</div>

<!-- Map view -->
<div class="galaxy-map-wrap" *ngIf="galaxyView === 'map'"
     (mousemove)="onGalaxyMapMouseMove($event)"
     (mousedown)="onGalaxyMapMouseDown($event)"
     (mouseup)="onGalaxyMapMouseUp()"
     (mouseleave)="onGalaxyMapMouseLeave()"
     (wheel)="onGalaxyWheel($event)"
     (touchstart)="onGalaxyTouchStart($event)"
     (touchmove)="onGalaxyTouchMove($event)"
     (touchend)="onGalaxyTouchEnd($event)"
     style="touch-action:none;">
  <svg class="galaxy-map-svg" viewBox="0 0 480 480" preserveAspectRatio="xMidYMid meet">
    <!-- Static background stars -->
    <circle *ngFor="let s of galaxyBgStars"
            [attr.cx]="s.x" [attr.cy]="s.y" [attr.r]="s.r"
            [attr.opacity]="s.o" class="bg-star"/>
    <!-- Pan/zoom group -->
    <g [attr.transform]="galaxyTransform">
      <!-- Travel paths -->
      <line *ngFor="let lnk of galaxyMapLinks"
            [attr.x1]="lnk.x1" [attr.y1]="lnk.y1"
            [attr.x2]="lnk.x2" [attr.y2]="lnk.y2"
            class="map-link"/>
      <!-- Star systems -->
      <g *ngFor="let node of galaxyMapNodes"
         (mouseenter)="galaxyMapHovered = node"
         (mouseleave)="galaxyMapHovered = null"
         (click)="onGalaxySystemTap(node)"
         class="map-sys-g">
        <circle [attr.cx]="node.svgX" [attr.cy]="node.svgY"
                [attr.r]="node.colorClass === 'dot-unclaimed' ? 2.5 : 5"
                [class]="'map-dot ' + node.colorClass"/>
        <!-- Cooldown label -->
        <text *ngIf="node.cooldownShort"
              [attr.x]="node.svgX" [attr.y]="node.svgY + 11"
              class="map-timer-label" [class]="'map-timer-label ' + node.colorClass">{{ node.cooldownShort }}</text>
      </g>
    </g>
  </svg>
  <!-- Legend -->
  <div class="galaxy-map-legend">
    <span class="legend-item"><span class="legend-dot dot-available"></span>Available</span>
    <span class="legend-item"><span class="legend-dot dot-cooldown"></span>Cooldown</span>
    <span class="legend-item"><span class="legend-dot dot-immune"></span>Immune</span>
    <span class="legend-item"><span class="legend-dot dot-attacking"></span>Under Attack</span>
    <span class="legend-item"><span class="legend-dot dot-unclaimed"></span>Unclaimed</span>
  </div>
  <!-- Hover / tap tooltip -->
  <div class="galaxy-map-tooltip" *ngIf="galaxyMapHovered"
       [style.left.px]="galaxyMapTooltipX"
       [style.top.px]="galaxyMapTooltipY">
    <div class="gmt-title">{{ galaxyMapHovered.title }}</div>
    <div class="gmt-owner" *ngIf="galaxyMapHovered.ownerName">{{ galaxyMapHovered.ownerName }}</div>
    <div class="gmt-owner gmt-unclaimed" *ngIf="!galaxyMapHovered.ownerName">Unclaimed</div>
    <div class="gmt-attacker" *ngIf="galaxyMapHovered.attackerName">&#9888; {{ galaxyMapHovered.attackerName }}</div>
    <div *ngIf="galaxyMapHovered.cooldownText !== '—'"
         [class]="'gmt-timer ' + galaxyMapHovered.cooldownClass">{{ galaxyMapHovered.cooldownText }}</div>
  </div>
</div>
